import styles from "./card.module.css";
import { getNudgingMessage, detectProductType } from '../../utils/nudgingMessages';
import { formatPrice } from '../../utils/formatPrice';

const MenuCard = ({ item, categoryId, categoryName = '', brutalistStyle = false }) => {
  // Reemplazar \r\n con <br/>
  let formattedDescription = item.description
    ? item.description.replace(/\n/g, '<br/>')
    : '';

  // Detectar badges basado en flags del producto
  const badges = [];
  if (item.isRecommended || item.recommended) badges.push({ type: 'recommended', label: 'Recomendado' });
  if (item.isMostOrdered || item.mostOrdered) badges.push({ type: 'mostOrdered', label: 'Más pedido' });
  if (item.isSignature || item.signature) badges.push({ type: 'signature', label: 'Signature' });
  if (item.isShareable || item.shareable) badges.push({ type: 'shareable', label: 'Ideal para compartir' });
  if (item.isProductOfDay || item.productOfDay) badges.push({ type: 'productOfDay', label: 'Producto del día' });

  // Determinar si es premium (precio alto o signature)
  const isPremium = (item.price / 100) > 15 || item.isSignature || item.signature;
  const price = formatPrice(item.price);

  // Obtener mensaje de nudging si no hay pairingSuggestion
  const productType = detectProductType(item.name, categoryName);
  const nudgingMessage = !item.pairingSuggestion && (item.isRecommended || item.isMostOrdered || item.isSignature)
    ? getNudgingMessage(productType, item.name)
    : null;

  // Mostrar imagen para la categoría de vinos naturales, pero no en estilo brutalista
  // (por nombre: el id numérico viejo de Tiller ya no existe en SumUp)
  const showImage = categoryName.toLowerCase().includes('vinos naturales') && !brutalistStyle;

  return (
    <div className={`${styles.menuCard} ${isPremium ? styles.premium : ''} ${!showImage ? styles.noImage : ''} ${brutalistStyle ? styles.brutalist : ''}`}>
      {/* Badges container */}
      {badges.length > 0 && (
        <div className={styles.badgesContainer}>
          {badges.map((badge, index) => (
            <span key={index} className={`${styles.badge} ${styles[badge.type]}`}>
              {badge.type === 'recommended' && '⭐'}
              {badge.type === 'mostOrdered' && '🔥'}
              {badge.type === 'signature' && '✨'}
              {badge.type === 'shareable' && '👥'}
              {badge.type === 'productOfDay' && '🌟'}
              <span className={styles.badgeLabel}>{badge.label}</span>
            </span>
          ))}
        </div>
      )}

      {/* Mostrar sección de imagen para vinos naturales */}
      {showImage && (
        <div className={styles.cardImage}>
          <img
            src={item.image?.small || require('../../Assets/Placeholder.png')}
            alt={item.name}
            className={item.image?.small ? styles.menuCardImage : styles.placeholderImage}
            loading="lazy"
          />
        </div>
      )}
      
      <div className={styles.cardcontent}>
        <div className={styles.cardHeader}>
          <h3 className={styles.menuCardTitle}>{item.name}</h3>
          {!brutalistStyle && (
            <div className={styles.priceContainer}>
              <span className={styles.menuCardPrice}>{price}</span>
            </div>
          )}
        </div>
        
        {formattedDescription && (
          <p 
            className={styles.menuCardDescription} 
            dangerouslySetInnerHTML={{ __html: formattedDescription }}
          />
        )}

        {/* Precio debajo de la descripción en estilo brutalista */}
        {brutalistStyle && (
          <div className={styles.priceContainer}>
            <span className={styles.menuCardPrice}>{price}</span>
          </div>
        )}

        {/* Microcopy de nudging */}
        {(item.pairingSuggestion || nudgingMessage) && (
          <p className={styles.pairingSuggestion}>
            💡 {item.pairingSuggestion || nudgingMessage}
          </p>
        )}
      </div>
    </div>
  );
};

export default MenuCard;
